// Import model
import { StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest } from '../models/StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest instance
   */
  static deserialize(json: string): StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest instance
   */
  static fromObject(obj: any): StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest');
    }


    const instance: StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest instances
   */
  static deserializeArray(json: string): StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest instance to a plain object
   */
  static toObject(instance: StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAppointmentInitiateSmsForUpcomingApppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
